// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AsyncPanel_wrapper__8pEk9","start":"AsyncPanel_start__-7eR-","visible":"AsyncPanel_visible__vB8x3","extraWide":"AsyncPanel_extraWide__1CWi1"};